import React, { Component } from 'react';
import {
    Collapse,
    Container,
    Navbar,
    NavbarBrand,
    NavbarToggler,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);
        this.state = {
            collapsed: true
        };

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.logout = this.logout.bind(this);
    }

    toggleNavbar() {
        this.setState({ collapsed: !this.state.collapsed });
    }

    logout() {
        this.props.logout();
    }

    // Helper to check if a user has a given permission
    hasPermission = (perm) => this.props.userPermissions.includes(perm);

    render() {
        const { appPermissions, activeApp, userName } = this.props;

        // Build an array of dropdown menu items based on permissions
        const dropdowns = [];

        if (this.hasPermission(appPermissions.PICK_SALES_ORDERS)) {
            dropdowns.push(
                <UncontrolledDropdown nav inNavbar key="picking">
                    <DropdownToggle nav caret>
                        WMS SO Picking
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem>
                            <NavLink tag={Link} className="text-dark" to="/AssignSOP">
                                Assign SO
                            </NavLink>
                        </DropdownItem>
                        <DropdownItem>
                            <NavLink tag={Link} className="text-dark" to="/MoveRepick">
                                Move Repick
                            </NavLink>
                        </DropdownItem>
                        <DropdownItem>
                            <NavLink tag={Link} className="text-dark" to="/PickSummary">
                                Pick Summary
                            </NavLink>
                        </DropdownItem>
                        <DropdownItem>
                            <NavLink tag={Link} className="text-dark" to="/SOP">
                                SO Picking
                            </NavLink>
                        </DropdownItem>
                        <DropdownItem>
                            <NavLink tag={Link} className="text-dark" to="/SOPSummary">
                                Tote Order Info
                            </NavLink>
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            );
        }

        if (this.hasPermission(appPermissions.MANAGE_BINS)) {
            dropdowns.push(
                <UncontrolledDropdown nav inNavbar key="bins">
                    <DropdownToggle nav caret>
                        WMS Bins
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem>
                            <NavLink tag={Link} className="text-dark" to="/BinPutway">
                                Bin Putaway
                            </NavLink>
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            );
        }

        if (this.hasPermission(appPermissions.ITEM_LOOKUP)) {
            dropdowns.push(
                <UncontrolledDropdown nav inNavbar key="inventory">
                    <DropdownToggle nav caret>
                        Inventory
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem>
                            <NavLink tag={Link} className="text-dark" to="/ItemLookup">
                                Item Lookup
                            </NavLink>
                        </DropdownItem>
                        {this.hasPermission(appPermissions.EXPIRATION_DATE_MANAGEMENT) && (
                            <DropdownItem>
                                <NavLink tag={Link} className="text-dark" to="/ManageExpiration">
                                    Manage Expiration
                                </NavLink>
                            </DropdownItem>
                        )}
                        {this.hasPermission(appPermissions.SUBLOCATION_MANAGEMENT) && (
                            <DropdownItem>
                                <NavLink tag={Link} className="text-dark" to="/ManageSublocations">
                                    Manage Sublocations
                                </NavLink>
                            </DropdownItem>
                        )}
                    </DropdownMenu>
                </UncontrolledDropdown>
            );
        }

        if (this.hasPermission(appPermissions.WMS_NAMETAGS)) {
            dropdowns.push(
                <UncontrolledDropdown nav inNavbar key="nametags">
                    <DropdownToggle nav caret>
                        WMS Nametags
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem>
                            <NavLink tag={Link} className="text-dark" to="/NametagApproval">
                                Nametag Approval
                            </NavLink>
                        </DropdownItem>
                        <DropdownItem>
                            <NavLink tag={Link} className="text-dark" to="/NametagReceiving">
                                Nametag Receiving
                            </NavLink>
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            );
        }

        return (
            <header className="nav-menu-header">
                <Navbar
                    className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3 nav-menu-navbar"
                    light
                >
                    <Container>
                        <NavbarBrand className="navbarTitle" tag={Link} to="/">
                            BYU Store WMS
                        </NavbarBrand>
                        <h1>{activeApp}</h1>
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                        <Collapse
                            className="d-sm-inline-flex flex-sm-row-reverse"
                            isOpen={!this.state.collapsed}
                            navbar
                        >
                            <b>
                                {userName} - <button onClick={this.logout}>Logout</button>
                            </b>
                            <ul className="navbar-nav flex-grow">
                                {dropdowns}
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }
}
